<template>
  <div>
    <div style="width: 100%;height: 100%;display: flex;flex-wrap: wrap;
    align-content: space-between;">
      <div class="column">
        <img style="width: 50%;margin:4px 4px" src="../assets/img/aidl.png" alt="">
        <img style="width: 50%;margin:4px 4px" src="../assets/img/aiimg2.png" alt="">
      </div>
      <div class="column">
        <img style="width: 50%;margin: 4px 4px" src="../assets/img/aiimg3.png" alt="">
        <img style="width: 50%;margin: 4px 4px" src="../assets/img/aiimg4.png" alt="">
      </div>
    </div>
    <div style="width: 100%;height: 100%;display: flex;justify-content: center;margin: 40px 0 80px">
      <div style="width: 80%;height: 100%;display: flex;flex-direction: column">
        <div style="display: flex;width: 100%;justify-content: space-around">
          <div style="width: 18%;display: flex;align-items: center"><img style="width: auto;height:auto;max-height: 100%;max-width: 100%" src="../assets/img/aiimg6.png" alt=""></div>
          <div style="width: 18%;display: flex;align-items: center"><img style="width: auto;height:auto;max-height: 100%;max-width: 100%" src="../assets/img/aiimg7.png" alt=""></div>
          <div style="width: 18%;display: flex;align-items: center"><img style="width: auto;height:auto;max-height: 100%;max-width: 100%" src="../assets/img/aiimg8.png" alt=""></div>
          <div style="width: 18%;display: flex;align-items: center"><img style="width: auto;height:auto;ax-height: 100%;max-width: 100%" src="../assets/img/aiimg9.png" alt=""></div>
        </div>

        <div style="display: flex;width: 100%;justify-content: space-around;font-size: 14px;

font-weight: 400;
color: #6C6D6D;
line-height: 25px;">
          <div style="width: 18%;display: flex;">
            实训课程可能具备多个实训单元同步进行训练， 教师需要有效的进行管理 、 安排学训练、 全局查看所有单元训练情况和进度、 安排考核。
          </div>
          <div style="width: 18%;display: flex;">
            每—位学生的每—次训练记录都可以选择保存在平台中， 方便学生和教师后续查看以及后台分析挖掘， 从中发现学生实训能力提升轨迹， 追踪整个学习训练的过程，
          </div>
          <div style="width: 18%;display: flex;">
            针对学校级别应用， 汇总所有实训单元数据， 提供丰富统计功能。 同时基于实训能力画像模型， 针对学生能力倾向， 进步趋势等全面刻画学生实训能力。
          </div>
          <div style="width: 18%;display: flex;">
            为考核评估和能力画像提供了依据。 数据回溯：平台支持调取之前的实训记录， 能够逐帧回溯每—次训练过程的每—个时刻动作， 方便进行教学分析。
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  // 虚拟仿真
  name: "Zitai.vue",
  components: {
  },
  data () {
    return {
      dataTitle:'姿态分析',
      dataList:[
        {
          title:'身临其境',
          logo:require("../assets/img/zitai/imgs3.png"),
          src:require("../assets/img/zitai/contentinfo3.png")
        },
        {
          title:'身入虚境',
          logo:require("../assets/img/zitai/imgs2.png"),
          src:require("../assets/img/zitai/contentinfo2.png")
        },
        {
          title:'身入幻境',
          logo:require("../assets/img/zitai/imgs1.png"),
          src:require("../assets/img/zitai/contentinfo1.png")
        }
      ]
    }
  },
  methods: {

  },

}
</script>

<style lang="scss" scoped>
.column {
  flex-basis: 100%;
  display: flex;
  justify-content: space-between;
}
.el-col{
  height: 100%;
}
@import '../assets/css/Cihidai.scss';
</style>


